import ProfileLayout from '../layouts/ProfileLayout'
import { ProjectPage } from '../pages/Profile/ProjectPage'
import { SocialOrder } from '../pages/Profile/SocialOrder'
import { CreateSocialOrder } from '../pages/Profile/CreateSocialOrder'
import { EditSocialOrder } from '../pages/Profile/EditSocialOrder'
import { EditSocialOrderForm } from '../pages/Profile/EditSocialOrder/EditSocialOrderForm'
import { EditSocialOrderAdministrationForm, EditSocialOrderImagesForm } from '../pages/Profile/EditSocialOrder/Tabs'
import { SocialOrdersLayout } from '../pages/Profile/SocialOrders/SocialOrdersLayout'
import { SocialOrdersAll } from '../pages/Profile/SocialOrders/SocialOrdersAll'
import { SocialOrdersSubscriptions } from '../pages/Profile/SocialOrders/SocialOrdersSubscriptions'
import { SocialOrdersMine } from '../pages/Profile/SocialOrders/SocialOrdersMine'
import { routesProfile } from '../consts'
import { RequireAuth } from '../hoc/RequireAuth'
import { TeamsLayout } from '../pages/Profile/Teams/TeamsLayout'
import { TeamsAll } from '../pages/Profile/Teams/TeamsAll'
import { TeamsSubscriptions } from '../pages/Profile/Teams/TeamsSubscriptions'
import { TeamsMine } from '../pages/Profile/Teams/TeamsMine'
import { TeamsParticipating } from '../pages/Profile/Teams/TeamsParticipating'
import { CreateGrowthTool } from '../pages/Profile/CreateGrowthTool'
import { EditGrowthTool } from '../pages/Profile/EditGrowthTool'
import { EditGrowthToolForm } from '../pages/Profile/EditGrowthTool/EditGrowthToolForm'
import { EditGrowthToolAdministrationForm, EditGrowthToolImagesForm } from '../pages/Profile/EditGrowthTool/Tabs'
import {
  EventsLayout,
  EventsAllPage,
  EventsRepliesPage,
  EventsRequestsPage,
  EventsSocialOrdersPage,
  EventsTeamSpacePage,
} from '../pages/Profile/Events'
import {
  RecommendationsForMePage,
  RecommendationsForMyProjectsPage,
  RecommendationsForResourcesPage,
  RecommendationsForMyTeamsPage,
  RecommendationsLayout,
} from '../pages/Profile/Recommendations'
import { Settings } from '../pages/Profile/Settings'
import { StaffPlatformReportsPage } from '../pages/Profile/StaffPlatformReportsPage'
import { UserProfileSettings } from '../pages/Profile/UserProfileSettings'
import { TeamPage } from '../pages/Profile/TeamPage'
import { CreateTeam } from '../pages/Profile/CreateTeam'
import { EditTeam } from '../pages/Profile/EditTeam'
import { EditTeamForm as EditEntityTeamProfileForm } from '../pages/Profile/EditTeam/EditTeamForm'
import { EditTeamMembersForm, EditTeamAdministrationForm } from '../pages/Profile/EditTeam/Tabs'
import { Navigate, Outlet } from 'react-router-dom'
import { UserPage } from '../pages/Profile/UserPage'
import { UserSocialOrders } from '../pages/Profile/UserPage/Activities/UserSocialOrders'
import { UserProjects } from '../pages/Profile/UserPage/Activities/UserProjects'
import { Description } from '../components/ProjectPage/Sections/Description'
import { ActionPlan } from '../components/ProjectPage/Sections/ActionPlan'
import { Needs } from '../components/ProjectPage/Sections/Needs'
import { WhoNeeded } from '../components/ProjectPage/Sections/Needs/ChildrenComponents/WhoNeeded'
import { WhatNeeded } from '../components/ProjectPage/Sections/Needs/ChildrenComponents/WhatNeeded'
import { WhoAvailable } from '../components/ProjectPage/Sections/Needs/ChildrenComponents/WhoAvailable'
import { WhatAvailable } from '../components/ProjectPage/Sections/Needs/ChildrenComponents/WhatAvailable'
import { TeamSpace } from '../components/ProjectPage/Sections/TeamSpace'
import { ProjectRecommendations } from '../components/ProjectPage/Sections/Recommendations'
import { ProjectRecommendationsWhoNeeded } from '../components/ProjectPage/Sections/Recommendations/WhoNeeded'
import { ProjectRecommendationsWhatNeeded } from '../components/ProjectPage/Sections/Recommendations/WhatNeeded'
import { CreateProject } from '../pages/Profile/CreateProject'
import { EditProject } from '../pages/Profile/EditProject'
import {
  EditDescriptionForm,
  EditImagesForm,
  EditActionPlanForm,
  EditTeamForm,
  EditAdministrationForm,
  EditNeedsLayout,
  EditWhoNeededForm,
  EditWhatNeededForm,
  EditWhoAvailableForm,
  EditWhatAvailableForm
} from '../pages/Profile/EditProject/Tabs'
import { GrowthToolsLayout } from '../pages/Profile/GrowthTools/GrowthToolsLayout'
import { GrowthToolsAll } from '../pages/Profile/GrowthTools/GrowthToolsAll'
import { GrowthToolsSubscriptions } from '../pages/Profile/GrowthTools/GrowthToolsSubscriptions'
import { GrowthToolsMine } from '../pages/Profile/GrowthTools/GrowthToolsMine'
import { GrowthTool } from '../pages/Profile/GrowthTool'
import { ProjectsLayout } from '../pages/Profile/ProjectsPage/ProjectsLayout'
import { ProjectsAll } from '../pages/Profile/ProjectsPage/ProjectsAll'
import { ProjectsSubscriptions } from '../pages/Profile/ProjectsPage/ProjectsSubscriptions'
import { ProjectsMine } from '../pages/Profile/ProjectsPage/ProjectsMine'
import { ProjectsParticipating } from '../pages/Profile/ProjectsPage/ProjectsParticipating'
import { UsersLayout } from '../pages/Profile/Users/UsersLayout'
import { UsersAll } from '../pages/Profile/Users/UsersAll'
import { UsersSubscriptions } from '../pages/Profile/Users/UsersSubscriptions'

export const profileRoutes = [
  {
    path: routesProfile.ROOT.path,
    element: (
      <RequireAuth>
        <ProfileLayout />
      </RequireAuth>
    ),
    permissions: routesProfile.ROOT.permissions,
    children: [
      {
        element: <EventsLayout />,
        permissions: routesProfile.ROOT.permissions,
        children: [
          {
            index: true,
            element: <EventsAllPage />,
          },
          {
            path: 'replies',
            element: <EventsRepliesPage />,
          },
          {
            path: 'requests',
            element: <EventsRequestsPage />,
          },
          {
            path: 'social-orders',
            element: <EventsSocialOrdersPage />,
          },
          {
            path: 'team-space',
            element: <EventsTeamSpacePage />,
          },
        ],
      },
      {
        path: routesProfile.RECOMMENDATIONS.path,
        element: (
          <RequireAuth>
            <RecommendationsLayout />
          </RequireAuth>
        ),
        permissions: routesProfile.ROOT.permissions,
        children: [
          {
            index: true,
            element: (
              <RequireAuth>
                <RecommendationsForMePage />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
          {
            path: 'projects',
            element: (
              <RequireAuth>
                <RecommendationsForMyProjectsPage />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
          {
            path: 'resources',
            element: (
              <RequireAuth>
                <RecommendationsForResourcesPage />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
          {
            path: 'teams',
            element: (
              <RequireAuth>
                <RecommendationsForMyTeamsPage />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
          {
            path: '*',
            element: <Navigate to={`/${routesProfile.RECOMMENDATIONS.path}`} replace />,
          },
        ],
      },
      {
        path: routesProfile.PROJECTS.path,
        element: (
          <RequireAuth>
            <Outlet />
          </RequireAuth>
        ),
        permissions: routesProfile.ROOT.permissions,
        children: [
          {
            path: '',
            element: (
              <RequireAuth>
                <ProjectsLayout />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <ProjectsAll />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: '*',
                element: <Navigate to={`/${routesProfile.PROJECTS.path}`} replace />,
              },
            ],
          },
          {
            path: 'subscriptions',
            element: (
              <RequireAuth>
                <ProjectsLayout />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <ProjectsSubscriptions />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: '*',
                element: <Navigate to={`/${routesProfile.PROJECTS.path}/subscriptions`} replace />,
              },
            ],
          },
          {
            path: 'mine',
            element: (
              <RequireAuth>
                <ProjectsLayout />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <ProjectsMine />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: '*',
                element: <Navigate to={`/${routesProfile.PROJECTS.path}/mine`} replace />,
              },
            ],
          },
          {
            path: 'participating',
            element: (
              <RequireAuth>
                <ProjectsLayout />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <ProjectsParticipating />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: '*',
                element: <Navigate to={`/${routesProfile.PROJECTS.path}/participating`} replace />,
              },
            ],
          },
          {
            path: 'create',
            element: (
              <RequireAuth>
                <CreateProject />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
          {
            path: ':id/edit',
            element: (
              <RequireAuth>
                <EditProject />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <EditDescriptionForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'team',
                element: (
                  <RequireAuth>
                    <EditTeamForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'administration',
                element: (
                  <RequireAuth>
                    <EditAdministrationForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'images',
                element: (
                  <RequireAuth>
                    <EditImagesForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'actionplan',
                element: (
                  <RequireAuth>
                    <EditActionPlanForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'needs',
                element: (
                  <RequireAuth>
                    <EditNeedsLayout />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
                children: [
                  {
                    index: true,
                    element: <Navigate to="whoneeded" replace />,
                  },
                  {
                    path: 'whoneeded',
                    element: (
                      <RequireAuth>
                        <EditWhoNeededForm />
                      </RequireAuth>
                    ),
                    permissions: routesProfile.ROOT.permissions,
                  },
                  {
                    path: 'whatneeded',
                    element: (
                      <RequireAuth>
                        <EditWhatNeededForm />
                      </RequireAuth>
                    ),
                    permissions: routesProfile.ROOT.permissions,
                  },
                  {
                    path: 'whoavailable',
                    element: (
                      <RequireAuth>
                        <EditWhoAvailableForm />
                      </RequireAuth>
                    ),
                    permissions: routesProfile.ROOT.permissions,
                  },
                  {
                    path: 'whatavailable',
                    element: (
                      <RequireAuth>
                        <EditWhatAvailableForm />
                      </RequireAuth>
                    ),
                    permissions: routesProfile.ROOT.permissions,
                  },
                ],
              },
            ],
          },
          {
            path: ':slug',
            element: (
              <RequireAuth>
                <ProjectPage />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <Description />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'recommendations',
                element: (
                  <RequireAuth>
                    <ProjectRecommendations />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
                children: [
                  {
                    index: true,
                    element: <Navigate to="whoneeded" replace />,
                  },
                  {
                    path: 'whoneeded',
                    element: (
                      <RequireAuth>
                        <ProjectRecommendationsWhoNeeded />
                      </RequireAuth>
                    ),
                    permissions: routesProfile.ROOT.permissions,
                  },
                  {
                    path: 'whatneeded',
                    element: (
                      <RequireAuth>
                        <ProjectRecommendationsWhatNeeded />
                      </RequireAuth>
                    ),
                    permissions: routesProfile.ROOT.permissions,
                  },
                ],
              },
              {
                path: 'actionplan',
                element: (
                  <RequireAuth>
                    <ActionPlan />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'needs',
                element: (
                  <RequireAuth>
                    <Needs />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
                children: [
                  {
                    path: 'whoneeded',
                    element: (
                      <RequireAuth>
                        <WhoNeeded />
                      </RequireAuth>
                    ),
                    permissions: routesProfile.ROOT.permissions,
                  },
                  {
                    path: 'whatneeded',
                    element: (
                      <RequireAuth>
                        <WhatNeeded />
                      </RequireAuth>
                    ),
                    permissions: routesProfile.ROOT.permissions,
                  },
                  {
                    path: 'whoavailable',
                    element: (
                      <RequireAuth>
                        <WhoAvailable />
                      </RequireAuth>
                    ),
                    permissions: routesProfile.ROOT.permissions,
                  },
                  {
                    path: 'whatavailable',
                    element: (
                      <RequireAuth>
                        <WhatAvailable />
                      </RequireAuth>
                    ),
                    permissions: routesProfile.ROOT.permissions,
                  },
                ]
              },
              {
                path: 'team-space',
                element: (
                  <RequireAuth>
                    <TeamSpace />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
            ]
          },
        ]
      },
      {
        path: routesProfile.SOCIALORDERS.path,
        element: (
          <RequireAuth>
            <Outlet />
          </RequireAuth>
        ),
        permissions: routesProfile.ROOT.permissions,
        children: [
          {
            path: 'create',
            element: (
              <RequireAuth>
                <CreateSocialOrder />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
          {
            path: ':id/edit',
            element: (
              <RequireAuth>
                <EditSocialOrder />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <EditSocialOrderForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'images',
                element: (
                  <RequireAuth>
                    <EditSocialOrderImagesForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'administration',
                element: (
                  <RequireAuth>
                    <EditSocialOrderAdministrationForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
            ],
          },
          {
            element: (
              <RequireAuth>
                <SocialOrdersLayout />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <SocialOrdersAll />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'subscriptions',
                element: (
                  <RequireAuth>
                    <SocialOrdersSubscriptions />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'mine',
                element: (
                  <RequireAuth>
                    <SocialOrdersMine />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
            ],
          },
          {
            path: ':id',
            element: (
              <RequireAuth>
                <SocialOrder />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
          {
            path: '*',
            element: <Navigate to={`/${routesProfile.SOCIALORDERS.path}`} replace />,
            permissions: routesProfile.ROOT.permissions,
          },
        ]
      },
      {
        path: routesProfile.USERS.path,
        element: (
          <RequireAuth>
            <Outlet />
          </RequireAuth>
        ),
        permissions: routesProfile.ROOT.permissions,
        children: [
          {
            path: '',
            element: (
              <RequireAuth>
                <UsersLayout />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <UsersAll />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: '*',
                element: <Navigate to={`/${routesProfile.USERS.path}`} replace />,
              },
            ],
          },
          {
            path: 'subscriptions',
            element: (
              <RequireAuth>
                <UsersLayout />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <UsersSubscriptions />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: '*',
                element: <Navigate to={`/${routesProfile.USERS.path}/subscriptions`} replace />,
              },
            ],
          },
          {
            path: ':slug',
            element: (
              <RequireAuth>
                <UserPage />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
          {
            path: ':id/projects',
            element: (
              <RequireAuth>
                <UserProjects />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
          {
            path: ':id/socialorders',
            element: (
              <RequireAuth>
                <UserSocialOrders />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
        ]
      },
      {
        path: routesProfile.TEAMS.path,
        element: (
          <RequireAuth>
            <Outlet />
          </RequireAuth>
        ),
        permissions: routesProfile.ROOT.permissions,
        children: [
          {
            path: '',
            element: (
              <RequireAuth>
                <TeamsLayout />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <TeamsAll />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: '*',
                element: <Navigate to={`/${routesProfile.TEAMS.path}`} replace />,
              },
            ],
          },
          {
            path: 'subscriptions',
            element: (
              <RequireAuth>
                <TeamsLayout />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <TeamsSubscriptions />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: '*',
                element: <Navigate to={`/${routesProfile.TEAMS.path}/subscriptions`} replace />,
              },
            ],
          },
          {
            path: 'mine',
            element: (
              <RequireAuth>
                <TeamsLayout />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <TeamsMine />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: '*',
                element: <Navigate to={`/${routesProfile.TEAMS.path}/mine`} replace />,
              },
            ],
          },
          {
            path: 'participating',
            element: (
              <RequireAuth>
                <TeamsLayout />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <TeamsParticipating />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: '*',
                element: <Navigate to={`/${routesProfile.TEAMS.path}/participating`} replace />,
              },
            ],
          },
          {
            path: 'create',
            element: (
              <RequireAuth>
                <CreateTeam />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
          {
            path: ':id/edit',
            element: (
              <RequireAuth>
                <EditTeam />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <EditEntityTeamProfileForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'members',
                element: (
                  <RequireAuth>
                    <EditTeamMembersForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'administration',
                element: (
                  <RequireAuth>
                    <EditTeamAdministrationForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
            ],
          },
          {
            path: ':id',
            element: (
              <RequireAuth>
                <TeamPage />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
        ]
      },
      {
        path: routesProfile.GROWTHTOOLS.path,
        element: (
          <RequireAuth>
            <Outlet />
          </RequireAuth>
        ),
        permissions: routesProfile.ROOT.permissions,
        children: [
          {
            path: 'create',
            element: (
              <RequireAuth>
                <CreateGrowthTool />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
          {
            path: ':id/edit',
            element: (
              <RequireAuth>
                <EditGrowthTool />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <EditGrowthToolForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'images',
                element: (
                  <RequireAuth>
                    <EditGrowthToolImagesForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'administration',
                element: (
                  <RequireAuth>
                    <EditGrowthToolAdministrationForm />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
            ],
          },
          {
            element: (
              <RequireAuth>
                <GrowthToolsLayout />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
            children: [
              {
                index: true,
                element: (
                  <RequireAuth>
                    <GrowthToolsAll />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'favorites',
                element: (
                  <RequireAuth>
                    <GrowthToolsSubscriptions />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
              {
                path: 'subscriptions',
                element: <Navigate to={`/${routesProfile.GROWTHTOOLS.path}/favorites`} replace />,
              },
              {
                path: 'mine',
                element: (
                  <RequireAuth>
                    <GrowthToolsMine />
                  </RequireAuth>
                ),
                permissions: routesProfile.ROOT.permissions,
              },
            ],
          },
          {
            path: ':id',
            element: (
              <RequireAuth>
                <GrowthTool />
              </RequireAuth>
            ),
            permissions: routesProfile.ROOT.permissions,
          },
          {
            path: '*',
            element: <Navigate to={`/${routesProfile.GROWTHTOOLS.path}`} replace />,
          },
        ]
      },
      {
        path: routesProfile.PROFILE.path,
        element: (
          <RequireAuth>
            <UserProfileSettings />
          </RequireAuth>
        ),
        permissions: routesProfile.ROOT.permissions,
      },
      {
        path: routesProfile.SETTINGS.path,
        element: (
          <RequireAuth>
            <Settings />
          </RequireAuth>
        ),
        permissions: routesProfile.ROOT.permissions,
      },
      {
        path: routesProfile.STAFF_REPORTS.path,
        element: (
          <RequireAuth>
            <StaffPlatformReportsPage />
          </RequireAuth>
        ),
        permissions: routesProfile.ROOT.permissions,
      },
      {
        path: `${routesProfile.ERROR.path}/:code`,
        element: (
          <RequireAuth>
            <div>
              <h1>Страница с ошибкой</h1>
            </div>
          </RequireAuth>
        ),
      },
      {
        path: '*',
        element: (
          <RequireAuth>
            <div>
              <h1>Страница с ошибкой</h1>
            </div>
          </RequireAuth>
        ),
      },
    ],
  },
]
